import React, { useState } from "react";

function Sidebar({ folders, onSelectFolder, loading, currentPath }) {
  const [expandedNodes, setExpandedNodes] = useState({});

  // Toggle expansion of a folder node
  const toggleNode = (nodePath) => {
    setExpandedNodes((prev) => ({
      ...prev,
      [nodePath]: !prev[nodePath],
    }));
  };

  const renderFolders = (folderList, parentPath = "\\") =>
    folderList.map((folder, index) => {
      const fullPath =
        parentPath === "\\"
          ? `\\${folder.label}`
          : `${parentPath}\\${folder.label}`;

      const isSelected = currentPath === fullPath;

      return (
        <li key={index}>
          <div
            onClick={() => {
              toggleNode(fullPath);
              if (!folder.children || folder.children.length === 0) {
                onSelectFolder(fullPath);
              }
            }}
            style={{
              cursor: folder.children ? "pointer" : "default",
              textDecoration: isSelected ? "underline" : "none",
              fontWeight: isSelected ? "bold" : "normal",
              color: isSelected ? "#84171A" : "inherit",
              display: "flex",
              alignItems: "center",
              // padding: "4px 0",
            }}
          >
            <i
              className={`fa-regular me-2 ${
                expandedNodes[fullPath] || isSelected
                  ? "fa-folder-open"
                  : "fa-folder"
              }`}
            ></i>
            {folder.label}
          </div>
          {folder.children && expandedNodes[fullPath] && (
            <ul style={{ paddingLeft: "20px", listStyle: "none" }}>
              {renderFolders(folder.children, fullPath)}{" "}
            </ul>
          )}
        </li>
      );
    });

  return (
    <div className="sidebar">
      <h5 className="mb-2">Folders</h5>
      {loading && (
        <div className="file-manager-loader-overlay">
          <div className="fa fa-spinner fs-7"></div>
        </div>
      )}
      <ul className="mb-0">{renderFolders(folders)}</ul> {}
    </div>
  );
}

export default Sidebar;
